/**
 * Shimmer skeleton — drop-in for the bare "Loading…" text the PWA used.
 * Three flavors: `Line` (single text row), `Rect` (arbitrary box), `Card`
 * (titled card placeholder). All share the `skeleton-shimmer` keyframes
 * declared in index.css.
 */

interface CommonProps {
  className?: string;
}

export function SkeletonLine({ className }: CommonProps) {
  return <div className={`skeleton-shimmer rounded-md h-3 ${className ?? 'w-3/4'}`} />;
}

export function SkeletonRect({ className }: CommonProps) {
  return <div className={`skeleton-shimmer rounded-md ${className ?? 'h-8 w-full'}`} />;
}

/** Card-style skeleton — title bar + 2 lines, mirrors a typical EventTile. */
export function SkeletonCard() {
  return (
    <div className="rounded-xl border border-mono-800 bg-mono-900/40 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <SkeletonRect className="h-4 w-1/2" />
        <SkeletonRect className="h-5 w-16 rounded-full" />
      </div>
      <SkeletonLine />
      <SkeletonRect className="h-1.5 w-full" />
    </div>
  );
}

/** Repeat helper — render N SkeletonCards. */
export function SkeletonCardList({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
